// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getAuth} from 'firebase/auth'
import { getFirestore, collection } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD2K3mhhu0pznlhO0m8CxzIJgNsDEnrvwM",
  authDomain: "htrend-4d67e.firebaseapp.com",
  projectId: "htrend-4d67e",
  storageBucket: "htrend-4d67e.appspot.com",
  messagingSenderId: "442986780379",
  appId: "1:442986780379:web:6109c4a6f47c6d4461defe",
  measurementId: "G-NRQBTXMWWV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const usersCollection = collection(firestore, 'users'); 
export { app }; // Export app
